<template>
	<div id="insuranceWechat">
		<div class="commonHeadbox">
			<el-form :inline="true">
				<el-form-item label="方案名称:">
					<el-input size="small " v-model="insure_name" placeholder="搜索方案名称" clearable style="width: 160px;"></el-input>
				</el-form-item>
				<el-form-item label="保险险种:">
					<el-select size="small" v-model="insure_type" placeholder="筛选保险险种" clearable style="width: 160px;">
					    <el-option label="个人意外险" :value="1"></el-option>
					    <el-option label="雇主责任险" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="保险类别:">
					<el-select size="small" v-model="insure_category" placeholder="筛选保险类别" clearable style="width: 160px;">
					    <el-option label="1-3类" value="1-3类"></el-option>
					    <el-option label="4类" value="4类"></el-option>
					    <el-option label="5类" value="5类"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="getList(1)">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		
		<div class="commonTablebox">
			<el-table v-loading="loading" :data="list" border :header-cell-style="{ background: '#fafafa', color: '#000' }">
				<el-table-column prop="parent_data.insure_name" label="方案名称" align="center"></el-table-column>
				<el-table-column prop="parent_data.insure_type" label="保险险种" align="center">
					<template slot-scope="scope">
						<span style="color: #E6A23C;" v-if="scope.row.parent_data.insure_type==1">个人意外险</span>
						<span style="color: #409EFF;" v-if="scope.row.parent_data.insure_type==2">雇主责任险</span>
					</template>
				</el-table-column>
				<el-table-column prop="parent_data.insure_category" label="保险类别" align="center"></el-table-column>
				<el-table-column label="投保方式" align="center">
					<el-table-column prop="insure_valid_day" label="投保时间（天）" align="center"></el-table-column>
					<el-table-column prop="premium" label="保费" align="center">
						<template slot-scope="scope">
							<span style="color: #67C23A;">{{scope.row.premium}}元</span>
						</template>
					</el-table-column>
					<el-table-column prop="insure_valid_type" label="生效方式" align="center">
						<template slot-scope="scope">
							<span style="color: #409EFF;" v-if="scope.row.insure_valid_type==1">立即生效</span>
							<span style="color: #F56C6C;" v-if="scope.row.insure_valid_type==2">次日生效</span>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column label="操作" align="center" width="120">
					<template slot-scope="scope">
						<el-button type="primary" size="small" @click="openChangeDialog(scope.row)">修改保费</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<div class="commonPages" v-if="total>10">
			<el-pagination background @current-change="getList" :current-page="page" :page-size="10"
				layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
		
		<el-dialog
			title="修改保费"
			:visible.sync="editShow"
			destroy-on-close
			:close-on-click-modal="false"
			width="450px">
			<div v-loading="editLoading" class="editbox">
				<el-form label-width="88px" label-position="left">
					<el-form-item label="方案名称:">
						<div>{{editForm.insure_name}}</div>
					</el-form-item>
					<el-form-item label="险种类别:">
						<span v-if="editForm.insure_type==1" style="color:#E6A23C;">个人意外险</span>
						<span v-else-if="editForm.insure_type==2" style="color:#409EFF;">雇主责任险</span>
						<span v-else style="color: #f00;">未知险种</span>
						<span style="margin-left: 12px;">{{editForm.insure_category}}</span>
					</el-form-item>
					<el-form-item label="投保方式:">
						<span style="color: #409EFF;margin-right: 12px;">保期{{editForm.insure_valid_day}}天</span>
						<span style="color: #409EFF;" v-if="editForm.insure_valid_type==1">立即生效</span>
						<span style="color: #F56C6C;" v-if="editForm.insure_valid_type==2">次日生效</span>
					</el-form-item>
					<el-form-item label="投保保费:">
						<el-input size="small" type="number" v-model="editForm.premium" placeholder="请输入保费">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
				</el-form>
				<div style="text-align: center;margin-top: 18px;">
					<el-button @click="editShow = false">取 消</el-button>
					<el-button type="primary" @click="editConfirm()">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {eltips} from '@/util/util.js'
	export default {
		name: "insuranceWechat",
		data() {
			return {
				insure_name:'',
				insure_type:'',
				insure_category:'',
				loading:false,
				list:[],
				total:0,
				page:1,
				editLoading:false,
				editShow:false,
				editForm:{
					id:'',
					insure_name:'',
					insure_type:'',
					insure_category:'',
					insure_valid_day:'',
					insure_valid_type:'',
					premium:'',
				}
			};
		},
		created() {
			this.getList()
		},
		methods:{
			editConfirm(){
				if(!this.editForm.premium) return eltips('请输入保费')
				this.editLoading = true
				let data = {
					id:this.editForm.id,
					premium:this.editForm.premium
				}
				this.axios.post('/api/main/Insure/insure_premium_edit',data).then(res=>{
					this.editLoading = false
					if(res.code==200){
						eltips(res.msg,'success')
						this.editShow = false
						this.getList()
					}else{
						eltips(res.msg,'error')
					}
				})
			},
			openChangeDialog(row){
				this.editForm = {
					id:row.id,
					insure_name:row.parent_data.insure_name,
					insure_type:row.parent_data.insure_type,
					insure_category:row.parent_data.insure_category,
					insure_valid_day:row.insure_valid_day,
					insure_valid_type:row.insure_valid_type,
					premium:row.premium,
				}
				this.editLoading = false
				this.editShow = true
			},
			getList(page){
				if(this.loading) return;
				this.loading = true
				if(page) this.page = page
				let data = {
					insure_name:this.insure_name,
					insure_type:this.insure_type,
					insure_category:this.insure_category,
					page:this.page
				}
				this.axios.get('/api/main/Insure/insure_details_list',{params:data}).then(res=>{
					this.loading = false
					if(res.code==200){
						this.total = res.data.total
						this.list = res.data.data
					}else{
						eltips(res.msg,'error')
					}
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	#insuranceWechat{
		min-height: calc(100vh - 70px);
	}
	
	.editbox /deep/ .el-form-item{
		margin-bottom: 10px !important;
	}
</style>